import debug from 'debug';
import {Icon, Page, Tile} from '../../shared';
import React from 'react';
import {GroupInfo} from '../widgets/containers';
import history from '../../history';
import useQueryObject from '../../shared/utils/useQueryObject';
import {getBackPath} from '../shared/utils/dashboardUtils';

const log = debug('circleblack:investor:pages:GroupInfo');

const GroupInfoPage = () => {
  log('rendering');
  const [context] = useQueryObject('context');

  const backPath = getBackPath();

  return <Page>
    <Tile key={'groupInfo'}
          title={'Group Info'}
          height={'calc(100vh - 200px)'}
          icon={<Icon svg={'arrowCircle'}
                      rotate={'180deg'}
                      action={() => history.push(backPath)}/>}>
      <GroupInfo containerID={context.containerID}/>
    </Tile>
  </Page>;
};

export default GroupInfoPage;
